import React from 'react'
import withRouter from "components/Common/withRouter";
import PropTypes from "prop-types";
import { Col, Container, Row } from 'reactstrap';

import AlertList from './AlertList'

import Breadcrumbs from "../../components/Common/Breadcrumb";
import Card from 'components/PurpleTheme/Card';

const AlertLog = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Row>
            <Col lg="8">
              <Breadcrumbs
                title={"Alert List"}
                breadcrumbItem={"Alert List"}
              />
            </Col>
          </Row>
          <Row>
            <Card>
            <Col lg="12">
              <AlertList />
            </Col>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AlertLog.propTypes = {
  t: PropTypes.any,
};

export default withRouter(AlertLog);